module.exports = __webpack_public_path__ + "img/logo-white.f48554ac.png";